const de = {
    common: {
        history: "historische Fassung"
    }
};
export default de;



// WEBPACK FOOTER //
// ./src/i18n/langs/de.js